const getLatestVersionId = (item: { draft?: unknown; versions: { id: string }[] }): string | undefined =>
  item.draft ? 'draft' : item.versions[0]?.id;

export default getLatestVersionId;
